import Loadable from "react-loadable";

// For chunk splitting
const loadableProps = {
  timeout: 60 * 1000,
};
const Loading = () => null;

const User = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "user" */ "@/pages/User/User"),
  loading: Loading,
});

const WechatConfig = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      /* webpackChunkName: "WechatConfig" */ "@/pages/WechatConfig/WechatConfig"
    ),
  loading: Loading,
});

const Score = Loadable({
  ...loadableProps,
  loader: () => import(/* webpackChunkName: "Score" */ "@/pages/Score/Score"),
  loading: Loading,
});

const Template = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "Template" */ "@/pages/Template/Template"),
  loading: Loading,
});

const RiskModel = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "RiskModel" */ "@/pages/Template/RiskModel"),
  loading: Loading,
});

const DmTemplate = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "DmTemplate" */ "@/pages/Template/DmTemplate"),
  loading: Loading,
});

const StoreBelong = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "StoreBelong" */ "@/pages/Store/StoreBelong"),
  loading: Loading,
});

const StoreList = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "StoreList" */ "@/pages/Store/StoreList"),
  loading: Loading,
});

const Country = Loadable({
  ...loadableProps,
  loader: () =>
    import(/* webpackChunkName: "Country" */ "@/pages/Store/Country"),
  loading: Loading,
});

const PackageList = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      /* webpackChunkName: "PackageList" */ "@/pages/PackageManagement/PackageList"
    ),
  loading: Loading,
});

const AiPackage = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      /* webpackChunkName: "AiPackage" */ "@/pages/PackageManagement/AiPackage"
    ),
  loading: Loading,
});

const OrderList = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      /* webpackChunkName: "OrderList" */ "@/pages/OrderManagement/OrderList"
    ),
  loading: Loading,
});

const PayoutsApproval = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      /* webpackChunkName: "PayoutsApproval" */ "@/pages/PayoutsApproval/PayoutsApproval"
    ),
  loading: Loading,
});

const BenefitConfig = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      /* webpackChunkName: "benefitConfig" */ "@/pages/system/BenefitConfig"
    ),
  loading: Loading,
});

const PayoutsConfig = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      /* webpackChunkName: "payoutsConfig" */ "@/pages/system/PayoutsConfig"
    ),
  loading: Loading,
});

const RankConfig = Loadable({
  ...loadableProps,
  loader: () =>
    import(
      /* webpackChunkName: "RankConfig" */ "@/pages/RankConfig/RankConfig"
    ),
  loading: Loading,
});

// Sub system component map
const subSystemMap = {
  User,
  WechatConfig,
  Score,
  Template,
  StoreBelong,
  StoreList,
  Country,
  PackageList,
  OrderList,
  BenefitConfig,
  PayoutsConfig,
  RiskModel,
  RankConfig,
  PayoutsApproval,
  AiPackage,
  DmTemplate,
};

export { subSystemMap };
